import {
  CREATE_CIRCULAR_REQUEST,
  CREATE_CIRCULAR_SUCCESS,
  CREATE_CIRCULAR_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  data: null,
  success:false,
};

const circularReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CIRCULAR_REQUEST:
      return { ...state, loading: true, error: null,success:false };

    case CREATE_CIRCULAR_SUCCESS:
      return { ...state, loading: false, data: action.payload,success:true };

    case CREATE_CIRCULAR_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    default:
      return state;
  }
};

export default circularReducer;
